import React from 'react'
import Footer from "./Footer-page/Footer"
const FooterSec = () => {
  return (
   <Footer />
  )
}

export default FooterSec